import http from 'plugins/axios';

export default {
    // 获取提币链提示信息列表
    getTipsList(data) {
        return http.get({
            url: '/wallet/admin/withdrawchainpromptconf/query',
            data
        });
    },
    // 获取所有链名称
    getChain() {
        return http.get({
            url: '/wallet/admin/withdrawchainpromptconf/getAllChain'
        });
    },
    // 新增/编辑提示信息
    addOrUpdate(data) {
        return http.post({
            url: '/wallet/admin/withdrawchainpromptconf/addOrUpdate',
            data: data
        });
    },
    // 删除提示信息
    deleteInfo(data) {
        return http.post({
            url: '/wallet/admin/withdrawchainpromptconf/delete',
            data: {
                id: data
            },
            dataType: 'form'
        });
    }
};
